<template lang="html">
    <div class="preloaderItem" :style="{ 'margin-bottom': mb + 'px' }">&nbsp;</div>
</template>

<script>
export default {
    name: "preloader-item",
    props: ["mb"],
};
</script>

<style lang="scss" scoped>
.preloaderItem {
    background: red;
    border-radius: 12px;
    height: 56px;
    margin-bottom: 20px;
    animation-duration: 1.25s;
    animation-fill-mode: forwards;
    animation-iteration-count: infinite;
    animation-name: placeHolderShimmer;
    animation-timing-function: linear;
    background: darkgray;
    background: linear-gradient(to right, #eff5f2 10%, darken(#eff5f2, 05) 18%, #eff5f2 33%);
    background-size: 800px 104px;
    position: relative;
}
@keyframes placeHolderShimmer {
    0% {
        background-position: -468px 0;
    }
    100% {
        background-position: 468px 0;
    }
}
</style>
